import axios from 'axios';
import authService from './authService';
import { API_BASE_URL } from '../config/api';

const closureApi = axios.create({
  baseURL: `${API_BASE_URL}/payroll-closures`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercepteur pour ajouter le token
closureApi.interceptors.request.use(
  (config) => {
    const token = authService.getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercepteur pour gérer les erreurs
closureApi.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    
    // Seulement rediriger vers login si c'est une erreur 401 (non authentifié)
    if (status === 401) {
      authService.logout();
      window.location.href = '/login';
      return Promise.reject(error);
    }
    
    // Pour 403 (accès refusé), on ne redirige pas, on laisse le composant gérer
    // Pour les autres erreurs, on les laisse aussi remonter au composant
    return Promise.reject(error);
  }
);

export const payrollClosureService = {
  getSummary: (year, month) => closureApi.get('/summary', { params: { year, month } }),
  closePeriod: (request) => closureApi.post('/close', request),
  getHistory: (year) => closureApi.get('/history', { params: { year } }),
  getDetails: (id) => closureApi.get(`/${id}`),
  reopenPeriod: (id, reason) => closureApi.post(`/${id}/reopen`, { reason }),
  checkPeriod: (year, month) => closureApi.get('/check', { params: { year, month } }),
};

export default payrollClosureService;

